module.exports = __webpack_public_path__ + "static/media/SFMono-Regular.7faa6660.woff2";